import { jwtDecode } from "jwt-decode"

export function storeToken(token: string) {
    localStorage.setItem('authToken', token)
}

export function getUser() {
    const storedToken = localStorage.getItem('authToken')
    if (!storedToken) return

    try {
        const decodedToken = jwtDecode(storedToken) as { [key: string]: any }
        return decodedToken
    } catch (error) {
        return
    }
}

export function isValidToken() {
    const storedToken = localStorage.getItem('authToken');
    if (!storedToken) return false

    try {
        const decodedToken = jwtDecode(storedToken) as { [key: string]: any };
        if (decodedToken && decodedToken.exp && Date.now() / 1000 < decodedToken.exp) {
            return true
        }

        return false
    } catch (error) {
        return false
    }
}

export function getToken() {
    return localStorage.getItem('authToken') as string
}
